import {useMemo} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationCtaState} from "../types/ReservationCtaState";
import {ReservationPlacement} from "../types/ReservationPlacement";
import {createReservationRequest} from "../utils/create_reservation_request";
import {getReservationCtaState} from "../utils/get_reservation_cta_state";
import {isPropertyReservationEligible} from "../utils/is_property_reservation_eligible";
import {useReservationAvailability} from "./use_reservation_availability";

export interface IPropertyReservationState {
    ctaState: ReservationCtaState;
    // null without a property that passes the SSR-safe part of the gate
    request: IReservationRequest | null;
}

/**
 * The reservation gate of a property - the buttons of the property page, the post-lead modal and the unlock choice all read it.
 * The server render and the first client render always agree: "hidden" or "reserved" come from the SSR data, everything else stays "pending" until availability is fetched on the client.
 * `property` is null while the host has no property, or when it does not offer the reservation at all.
 */
export const usePropertyReservationState = (property: IPropertyDetail | null, placement: ReservationPlacement): IPropertyReservationState => {
    const eligibleProperty = isPropertyReservationEligible(property) ? property : null;
    // a confirmed reservation sets these flags, so after a reload the button stays "reserved" instead of disappearing
    const isReservedBySsr = eligibleProperty !== null && (eligibleProperty.is_reserved || eligibleProperty.verbally_reservation === true);
    const {status, hasData, isError} = useReservationAvailability({
        propertyId: eligibleProperty?.id,
        isEnabled: eligibleProperty !== null && !isReservedBySsr
    });

    const request = useMemo(() => (eligibleProperty ? createReservationRequest(eligibleProperty, placement) : null), [eligibleProperty, placement]);

    return {
        ctaState: getReservationCtaState({isEligible: eligibleProperty !== null, isReservedBySsr, status, hasData, isError}),
        request
    };
};
import {useMemo} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationCtaState} from "../types/ReservationCtaState";
import {ReservationPlacement} from "../types/ReservationPlacement";
import {createReservationRequest} from "../utils/create_reservation_request";
import {getReservationCtaState} from "../utils/get_reservation_cta_state";
import {isPropertyReservationEligible} from "../utils/is_property_reservation_eligible";
import {useReservationAvailability} from "./use_reservation_availability";

export interface IPropertyReservationState {
    ctaState: ReservationCtaState;
    // null without a property that passes the SSR-safe part of the gate
    request: IReservationRequest | null;
}

/**
 * The reservation gate of a property - the buttons of the property page, the post-lead modal and the unlock choice all read it.
 * The server render and the first client render always agree: "hidden" or "reserved" come from the SSR data, everything else stays "pending" until availability is fetched on the client.
 * `property` is null while the host has no property, or when it does not offer the reservation at all.
 */
export const usePropertyReservationState = (property: IPropertyDetail | null, placement: ReservationPlacement): IPropertyReservationState => {
    const eligibleProperty = isPropertyReservationEligible(property) ? property : null;
    // a confirmed reservation sets these flags, so after a reload the button stays "reserved" instead of disappearing
    const isReservedBySsr = eligibleProperty !== null && (eligibleProperty.is_reserved || eligibleProperty.verbally_reservation === true);
    const {status, hasData, isError} = useReservationAvailability({
        propertyId: eligibleProperty?.id,
        isEnabled: eligibleProperty !== null && !isReservedBySsr
    });

    const request = useMemo(() => (eligibleProperty ? createReservationRequest(eligibleProperty, placement) : null), [eligibleProperty, placement]);

    return {
        ctaState: getReservationCtaState({isEligible: eligibleProperty !== null, isReservedBySsr, status, hasData, isError}),
        request
    };
};
